<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card>
      <md-card-header  data-background-color="newyellow" style="cursor: move;">
        <div
          style="display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;"
        >
          <h4 class="tittle">{{item.TITULO}}</h4>
          <v-btn
            v-if="logArray.length > 0"
            color="#88C658"
            class="ma-2 white--text"
            small
            fab
            v-clipboard="logArray"
            @click="msg = 'Copiado com sucesso.'"
          >
            <font-awesome-icon icon="copy" />
          </v-btn>
        </div>
      </md-card-header>
      <md-card-content>
        <div
          v-if="logArray.length > 0"
          style="
        padding: 10px;
    color: rgb(51, 51, 51);
    height: 300px;
    overflow-y: auto; font-family: 'Lucida Console'!important; font-size: 12px;"
        >
          <div v-for="(l,i) in logArray" :key="i">
            <v-badge color="#88C658" overlap>
              <template v-slot:badge>
                <span v-if="l.count > 0">{{ l.count }}</span>
              </template>

              <div style="padding-right: 30px;margin-bottom:0px;">
                <b style="font-weight: 900;">{{l.data | formatTimeNormal}}:</b>
                {{l.log}}
              </div>
            </v-badge>
            <br />
          </div>
        </div>
        <div v-else>
          <b style="font-weight: 900;margin: 20px;padding:10px">Aguardando por logs...</b>
        </div>
      </md-card-content>
    </md-card>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
export default {
  props: ["item"],
  sockets: {
    logsEMS(data) {
      var self = this;
      var rgx = this.decode(self.item.REGEX);
      var re = new RegExp(rgx, "im");

      var found = data.match(re);

      if (found) {
        var ndata = data.replace(re, self.item.SUBSTR);

        var newLog = { data: new Date(), log: ndata, count: 0 };
        self.logArray.forEach(element => {
          if (element.log == newLog.log) {
            newLog.count = element.count + 1;
            self.logArray.remove(element);
          }
        });
        self.logArray.unshift(newLog);
      }
    }
  },
  methods: {
    
    encode: function(s) {
      for (
        var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode;
        ++i < l;
        s[i] =
          (c = s[i].charCodeAt(0)) >= 127
            ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f))
            : s[i]
      );
      return s.join("");
    },
    decode: function(s) {
      for (
        var a,
          b,
          i = -1,
          l = (s = s.split("")).length,
          o = String.fromCharCode,
          c = "charCodeAt";
        ++i < l;
        (a = s[i][c](0)) & 0x80 &&
        ((s[i] =
          (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80
            ? o(((a & 0x03) << 6) + (b & 0x3f))
            : o(128)),
        (s[++i] = ""))
      );
      return s.join("");
    }
  },
  data() {
    return {
      msg: false,
      logArray: Array()
    };
  }
};
</script>
<style>
.configicon {
}
.v-badge__badge{
  top: 0!important;
      padding-top: 0px!important;
  font-size: 10px!important;
    width: 18px!important;
    height: 18px!important;
}
</style>